import { KV } from '../../core/Constant';
import Hls from './hls';

/**
 *
 *
 * @export
 * @class HlsPlayer
 * @extends {Hls}
 */
export default class HlsPlayer extends Hls {
  constructor(config = {}) {
    super(config);
    this.playedTime = 0;
  }

  getDownloadSize() {
    return this.getStore().getKV(KV.DownloadSize);
  }

  getEstimateNetSpeed() {
    return this.abrController.estimateNetSpeed;
  }

  setSrc(val) {
    return new Promise((resolve, reject) => {
      this.playedTime = this.getCurrentTime();
      this.playBackRate = this.getPlaybackRate();
      super.setSrc(val);
      // 停止当前的加载工作。准备切换线路
      this.networkControllers.forEach(component => {
        component.stopLoad();
      });
      // 添加新事件，清理完成后再加载新源。防止异步问题导致出错。
      this.once(Hls.Events.MEDIA_STREAM_DETACHED, () => {
        this.loadSource(val);
        this.attachMedia(this.video);
        // this.once(Hls.Events.MEDIA_ATTACHED, () => {
        //   // this.play();
        //   // 如果是点播的活动，卡顿切线，需要记录刚才播放到哪了。 然后再从刚才播放的时间继续播放
        //   if (!this.getIsLive()) {
        //     this.setCurrentTime(this.playedTime);
        //     this.setPlaybackRate(this.playBackRate);
        //   }
        // })

        // v2.3.9 避免切线跳帧, 事件顺序 ondurationchange => onloadedmetadata => onloadeddata
        // v2.3.9 切线后设置当前播放时间 ❌; 转到 setQuality | set currentDefinition 中设置
        this.video.ondurationchange = () => {
          resolve();
        }

        // 原方法在ie浏览器下失效，目前的监听方式兼容各个浏览器:
        this.video.onloadeddata = () => {
          // 切线过后，设置当前播放时间
          // 进入直播间时会seek(0),把外部seek的时间给覆盖掉了，故第一次setSrc不seek
          if (!this.getIsLive() && this._setSrcCount !== 1) {
            // this.setCurrentTime(this.playedTime);
            this.setPlaybackRate(this.playBackRate);
          }
        };
      });
      this.detachMedia();
    });
  }
}
